<template>
  <div class="menuFrame">
    <article class="indexMargin">
      <div class="contentBox">
        <!-- 標題列 -->
        <div class="PcDevice">
          <div class="d-flex justify-content-between align-items-center">
            <h1 class="display-4">歡迎使用參展商管理系統</h1>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="lead my-4">請先選擇您要管理的報名表：</div>
            <div>
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
          </div>
        </div>
        <div class="MbDevice">
          <p class="mb-2 ml-1" style="font-size: 13px; margin-top: 10px">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </p>
          <hr />
          <div class="font-weight-light h1">歡迎使用參展商管理系統</div>
          <div class="mt-3 mb-3 lead">請先選擇您要管理的報名表：</div>
        </div>
        <hr />

        <div v-show="hasExh">
          <!-- 全部展開/收合 -->
          <div class="d-flex justify-content-end align-items-center my-3">
            <span
              v-if="hasMultiShow"
              class="btn btn-outline-primary"
              @click="toggleAll"
            >
              {{ allOpen ? "全部收合" : "全部展開" }}
            </span>
          </div>

          <!-- 展覽分組 -->
          <ul
            v-for="show in shows"
            :key="show.exhcode"
            class="my-3 list-group-ul"
          >
            <li>
              <!-- 展覽表頭 -->
              <div
                class="row justify-content-between align-items-center"
                :style="{ cursor: show.multi ? 'pointer' : 'default' }"
                @click="show.multi ? toggle(show.exhcode) : null"
              >
                <div class="col-sm-8 text-sm-left text-center">
                  <div class="lineStyle align-items-center">
                    <div class="mr-sm-5">
                      <img
                        :src="`//www.ccie.com.tw/exhibition/images/exlogo/${show.ExhLogo}`"
                        class="img-fluid imgSize"
                      />
                    </div>
                    <div>
                      <p class="bold mb-1" style="font-size: 18px">
                        {{ show.Exhibition }}
                      </p>
                      <p class="gray mb-1">
                        {{ show.ExhBegin }} ~ {{ show.ExhEnd }}
                      </p>
                      <p class="gray">{{ show.ExhVenue }}</p>
                      <p class="divider">&nbsp;</p>

                      <!-- 單一廠商：直接顯示 -->
                      <template v-if="!show.multi">
                        <p>
                          <span class="colorBG">{{ show.only.AppNo }}</span>
                          {{ show.only.Directory_ComName }}
                        </p>
                        <p>展覽分區 : {{ show.only.ExhibArea }}</p>
                        <p>
                          攤位號碼 :
                          <span v-if="show.only.BoothNo == 'N/A'"> - </span>
                          <span v-else> {{ show.only.BoothNo }} </span>
                        </p>
                      </template>

                      <!-- 多廠商：顯示家數 + 展開 -->
                      <template v-else>
                        <p class="mb-1">
                          <span class="font-weight-bold">
                            {{ show.RegisterTotal }} 家參展公司
                          </span>
                          <span class="ml-2 text-primary expand-link">
                            {{ open[show.exhcode] ? "收合" : "展開查看" }}
                            <i
                              class="fas fa-chevron-down ml-1"
                              :class="{ 'rotate-180': open[show.exhcode] }"
                            ></i>
                          </span>
                        </p>
                        <p class="gray">展覽分區 : {{ show.zoneSummary }}</p>
                      </template>
                    </div>
                  </div>
                </div>

                <!-- 單一廠商：管理鈕 -->
                <div class="col-sm-4 text-right PcDevice" v-if="!show.multi">
                  <div v-if="show.only.Del == 'c'">
                    <div
                      class="btn btn-lg btn-primary"
                      @click.stop="ExhibitionHome(show.only.RegNo)"
                    >
                      管理
                    </div>
                  </div>
                  <div v-else-if="show.only.Del == 'd'">
                    <button
                      type="button"
                      class="btn btn-lg btn-secondary"
                      disabled
                    >
                      退展審核中
                    </button>
                  </div>
                </div>
                <div
                  class="col-sm-4 mb-2 text-center MbDevice"
                  v-if="!show.multi"
                >
                  <div v-if="show.only.Del == 'c'">
                    <div
                      class="btn btn-primary"
                      @click.stop="ExhibitionHome(show.only.RegNo)"
                    >
                      管理
                    </div>
                  </div>
                  <div v-else-if="show.only.Del == 'd'">
                    <button type="button" class="btn btn-secondary" disabled>
                      退展審核中
                    </button>
                  </div>
                </div>
              </div>

              <!-- 多廠商展開區 -->
              <div
                v-if="show.multi && open[show.exhcode]"
                class="company-expand mt-md-2 mt-0"
              >
                <!-- 搜尋框 -->
                <div
                  class="d-flex align-items-center flex-wrap mb-2 company-search"
                >
                  <div class="search-wrap mr-2">
                    <i class="fas fa-search search-icon"></i>
                    <input
                      type="text"
                      class="form-control search-input"
                      placeholder="搜尋公司名稱、展覽分區或攤位號碼"
                      :value="query[show.exhcode] || ''"
                      @input="setQuery(show.exhcode, $event.target.value)"
                    />
                    <span
                      v-if="query[show.exhcode]"
                      class="search-clear"
                      @click="setQuery(show.exhcode, '')"
                      >&times;</span
                    >
                  </div>
                  <span class="gray" v-if="query[show.exhcode]">
                    符合 {{ visibleCompanies(show).length }} /
                    {{ show.Registers.length }} 家
                  </span>
                </div>

                <p v-if="visibleCompanies(show).length === 0" class="gray py-2">
                  找不到符合的參展公司
                </p>

                <!-- 廠商列 -->
                <div
                  v-for="co in visibleCompanies(show)"
                  :key="co.RegNo"
                  class="company-row d-flex justify-content-between align-items-center flex-wrap py-2"
                >
                  <div class="company-info">
                    <p class="mb-1">
                      <span class="colorBG">{{ co.AppNo }}</span>
                      {{ co.Directory_ComName }}
                    </p>
                    <p class="gray mb-1">展覽分區 : {{ co.ExhibArea }}</p>
                    <p class="gray mb-0">
                      攤位號碼 :
                      <span v-if="co.BoothNo == 'N/A'"> - </span>
                      <span v-else>{{ co.BoothNo }}</span>
                    </p>
                  </div>
                  <div class="company-action">
                    <div
                      v-if="co.Del == 'c'"
                      class="btn btn-primary btn-lg"
                      @click="ExhibitionHome(co.RegNo)"
                    >
                      管理
                    </div>
                    <button
                      v-else-if="co.Del == 'd'"
                      type="button"
                      class="btn btn-secondary"
                      disabled
                    >
                      退展審核中
                    </button>
                  </div>
                </div>
              </div>
            </li>
            <hr />
          </ul>
        </div>

        <div v-show="!hasExh" style="font-size: 21px" class="pb-5 pt-4">
          您並非參展商，或是尚未被授予參展商管理權限，若有任何問題歡迎與我們<a
            href="https://www.chanchao.com.tw/contact.asp"
            target="_blank"
            >聯絡</a
          >。
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import axios from "axios";

const API_BASE = "https://www.chanchao.com.tw/apiExhibitors";

export default {
  components: {},

  metaInfo() {
    return {
      title: "展覽列表 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      ExhibitionList: [],
      UserId: "",
      hasExh: true,
      open: {}, // { exhcode: true }
      query: {}, // { exhcode: '關鍵字' }
    };
  },

  computed: {
    shows() {
      return this.ExhibitionList.map((s) => {
        const registers = s.Registers || [];
        const multi = registers.length > 1;
        const zones = [...new Set(registers.map((c) => c.ExhibArea))];
        return {
          ...s,
          multi,
          only: registers[0] || {},
          zoneSummary: zones.filter(Boolean).join("、"),
        };
      });
    },

    multiShows() {
      return this.shows.filter((s) => s.multi);
    },

    hasMultiShow() {
      return this.multiShows.length > 0;
    },

    allOpen() {
      return (
        this.multiShows.length > 0 &&
        this.multiShows.every((s) => this.open[s.exhcode])
      );
    },
  },

  methods: {
    ExhibitionHome(id) {
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/home?no=${id}`;
    },

    toggle(exhcode) {
      this.$set(this.open, exhcode, !this.open[exhcode]);
    },

    toggleAll() {
      if (this.allOpen) {
        this.open = {};
      } else {
        const next = {};
        this.multiShows.forEach((s) => {
          next[s.exhcode] = true;
        });
        this.open = next;
      }
    },

    setQuery(exhcode, val) {
      this.$set(this.query, exhcode, val);
    },

    visibleCompanies(show) {
      const q = (this.query[show.exhcode] || "").trim().toLowerCase();
      const list = show.Registers || [];
      if (!q) return list;
      return list.filter((c) =>
        `${c.Directory_ComName} ${c.AppNo} ${c.BoothNo} ${c.ExhibArea}`
          .toLowerCase()
          .includes(q),
      );
    },
  },

  created() {
    const vm = this;

    axios.get(`${API_BASE}/ExhibitionGroup?lang=tw`).then((response) => {
      if (response.data.Code == 200) {
        vm.ExhibitionList = response.data.Data;
        vm.hasExh = true;
      } else if (response.data.Code == 404) {
        vm.hasExh = false;
      } else {
        alert("系統忙線中，請稍後再試");
      }
    });

    axios.get(`${API_BASE}/UserID`).then((response) => {
      vm.UserId = response.data;
    });
  },
};
</script>

<style lang="scss">
.colorBG {
  background-color: #eee;
  display: inline;
  padding: 2px 5px;
}

.imgSize {
  width: 180px;
}

.lineStyle {
  display: flex;
}

.expand-link {
  cursor: pointer;
  font-weight: 500;
}

.expand-link .rotate-180 {
  transform: rotate(180deg);
  transition: transform 160ms ease;
}

/* 展開區對齊 logo 右側（= 展覽名稱起點）：logo 180px + mr-sm-5 48px */
.company-expand {
  padding-left: 228px;
}

.company-row {
  border-top: 1px solid #f0f0f0;
}

.company-info {
  min-width: 0;
}

.search-wrap {
  position: relative;
  flex: 1;
  max-width: 380px;
}

.search-input {
  padding-left: 30px;
  padding-right: 28px;
  font-size: 13px;
}

.search-icon {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #a5a5a5;
  z-index: 2;
}

.search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #a5a5a5;
  font-size: 18px;
  line-height: 1;
}

@media (max-width: 501px) {
  .lineStyle {
    display: block;
    margin-bottom: 25px;
  }

  .imgSize {
    width: 100px;
    margin-bottom: 15px;
  }

  /* 行動版：取消縮排、置中 */
  .company-expand {
    padding-left: 0;
  }

  .company-search {
    justify-content: center;
  }

  .company-row {
    display: block !important;
    text-align: center;
  }

  .company-action {
    margin-top: 10px;
  }

  /* 展開區管理鈕：手機壓回正常尺寸（桌機維持 btn-lg） */
  .company-action .btn-lg {
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
  }
}
</style>
